// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Franquias_GetConfiguracaoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response for /franquias/getConfiguracao — returns full franchise config.
 *
 * dados is a single Franquias_GetConfiguracaoRow when a configuracao_franquia
 * row exists for the franquia, or null when no config has been saved yet.
 */
import type { Franquias_GetConfiguracaoRow } from './Franquias_GetConfiguracaoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Franquias_GetConfiguracaoResponseDados = Franquias_GetConfiguracaoRow;

export type Franquias_GetConfiguracaoResponse = ApiResponse<Franquias_GetConfiguracaoResponseDados>;

registerResponseContract('Franquias_GetConfiguracaoResponse', {
  _nullable:                  { type: 'boolean', required: false },
  capacidade_producao_diaria: { type: 'number',  required: false },
  meta_producao_itens_dia:    { type: 'number',  required: false },
  meta_contatos_retomada_dia: { type: 'number',  required: false },
  valor_medio_item:           { type: 'string',  required: false },
  investimento_total:         { type: 'string',  required: false },
  roe_desejado:               { type: 'string',  required: false },
  meta_faturamento_mensal:    { type: 'string',  required: false },
  meta_faturamento_anual:     { type: 'string',  required: false },
  faturamento_mensal:         { type: 'string',  required: false },
  faturamento_anual:          { type: 'string',  required: false },
  cnpj:                       { type: 'string',  required: false },
  inscricao_estadual:         { type: 'string',  required: false },
  endereco:                   { type: 'string',  required: false },
  numero:                     { type: 'string',  required: false },
  complemento:                { type: 'string',  required: false },
  bairro:                     { type: 'string',  required: false },
  cidade:                     { type: 'string',  required: false },
  estado:                     { type: 'string',  required: false },
  cep:                        { type: 'string',  required: false },
  mensagem_aniversariante:    { type: 'string',  required: false },
  mensagem_boas_vindas:       { type: 'string',  required: false },
  abre_sabado:                { type: 'number',  required: false },
  abre_domingo:               { type: 'number',  required: false },
  dias_uteis_padrao:          { type: 'number',  required: false },
})
